import { Offcanvas } from 'bootstrap';
import Swiper from 'swiper';
import tplMenuMobile from './templates/menu_mobile.pug';

const menuMainMobile = []; // main mobile menu data

window.addEventListener('DOMContentLoaded', () => {

  CMS.DataStore.subscribe('menu/header', ({ initMobileMenu }) => {
    if (initMobileMenu) {
      // create mobile menu
      const btnMobileMenuTrigger = document.querySelector('[data-trigger-mobile-menu]');
      const { mobileMenu, mobileMenuEl, mobileMenuSlider } = createMobileMenu();
      mobileMenuEl.addEventListener('show.bs.offcanvas', () => {
        btnMobileMenuTrigger.classList.add('opened');
      });
      mobileMenuEl.addEventListener('hide.bs.offcanvas', () => {
        btnMobileMenuTrigger.classList.remove('opened');
      });
      mobileMenuEl.addEventListener('hidden.bs.offcanvas', () => {
        mobileMenuSlider.slideTo(0, 0, false);
      });

      // Mobile menu trigger button:
      btnMobileMenuTrigger.addEventListener('click', e => {
        e.preventDefault();
        mobileMenu.toggle();
      }, false);
    }
  });

  // // create mobile menu
  // const btnMobileMenuTrigger = document.querySelector('[data-trigger-mobile-menu]');
  // const { mobileMenu, mobileMenuEl, mobileMenuSlider } = createMobileMenu();
  // mobileMenuEl.addEventListener('show.bs.offcanvas', () => {
  //   btnMobileMenuTrigger.classList.add('opened');
  // });
  // mobileMenuEl.addEventListener('hide.bs.offcanvas', () => {
  //   btnMobileMenuTrigger.classList.remove('opened');
  // });
  // mobileMenuEl.addEventListener('hidden.bs.offcanvas', () => {
  //   mobileMenuSlider.slideTo(0, 0, false);
  // });

  // // Mobile menu trigger button:
  // const btnMobileMenuTrigger = document.querySelector('[data-trigger-mobile-menu]');
  // btnMobileMenuTrigger.addEventListener('click', e => {
  //   e.preventDefault();
  //   mobileMenu.toggle();
  // }, false);

});

/**
 * Create Bootstrap Offcanvas mobile menu
 * 
 * @param {object} options - Optional settings
 * 
 * @returns {Offcanvas}
 */
const createMobileMenu = (options = {}) => {
  const _defaults = {
    menuId: 'menuMobile',
    backdrop: true,
    keyboard: true,
    scroll: false,
  };
  const settings = { ..._defaults, ...options };

  // parse main menu:
  parseMenuMain(document.querySelector('.nav-header'));

  // parse top menu & add to main menu level 0
  if (document.querySelector('.nav-header-top')) {
    menuMainMobile[0].push(parseMenuTop(document.querySelector('.nav-header-top')));
  }

  // parse language selector menu
  let menuLang = null;
  if (document.querySelector('.nav-lang')) {
    menuLang = parseMenuLang(document.querySelector('.nav-lang'));
  }

  const html = tplMenuMobile({
    id: settings.menuId,
    menus: {
      main: menuMainMobile,
      lang: menuLang,
    },
  });
  document.body.insertAdjacentHTML('beforeend', html);
  const menuEl = document.querySelector(`#${settings.menuId}`);

  // create menu inner slider with events
  const slider = menuSlider();

  // init offcanvas
  const menu = new Offcanvas(menuEl, {
    backdrop: settings.backdrop,
    keyboard: settings.keyboard,
    scroll: settings.scroll,
  });

  return {
    mobileMenu: menu,
    mobileMenuEl: menuEl,
    mobileMenuSlider: slider,
  };
};

/**
 * Mobile menu slider
 * 
 * @param {object} options - Optional settings
 * @param {string} [options.sliderSelector=[data-slider="menu_mobile"]] - Slider CSS selector
 * 
 * @returns {Swiper}
 */
const menuSlider = (options = {}) => {
  const _defaults = {
    sliderSelector: '[data-slider="menu_mobile"]',
  };
  const settings = { ..._defaults, ...options };
  const sliderEl = document.querySelector(settings.sliderSelector);

  const slider = new Swiper(sliderEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    on: {
      slidePrevTransitionEnd: swiper => {
        // cleanup visible submenus (if needed)
        for (let i = swiper.activeIndex + 1; i < swiper.slides.length; i++) {
          Array.from(swiper.slides[i].querySelectorAll('.nav')).forEach(menuEl => menuEl.classList.add('d-none'));
        }
        swiper.updateSize();
      },
    },
  });

  // navigation inside slider
  Array.from(sliderEl.querySelectorAll('.nav-link')).forEach(linkEl => {
    linkEl.addEventListener('click', e => {
      if (
        linkEl.hasAttribute('data-level') && 
        linkEl.hasAttribute('data-menu')
      ) {
        e.preventDefault();

        const targetIndex = parseInt(linkEl.getAttribute('data-level'));
        const menuId = parseInt(linkEl.getAttribute('data-menu'));
        const targetSlideEl = slider.slides[targetIndex];
        const targetMenuEl = targetSlideEl.querySelector(`.nav[data-menu="${menuId}"]`);
        Array.from(targetSlideEl.querySelectorAll('.nav')).forEach(menuEl => menuEl.classList.add('d-none'));
        targetMenuEl.classList.remove('d-none');

        slider.slideNext(500);
      } else if (linkEl.hasAttribute('data-menu-back')) {
        e.preventDefault();
        slider.slidePrev(500);
      }
    }, false);
  });

  return slider;
};

/**
 * Parse main menu into mobile menu "format"
 * 
 * @param {HTMLElement} menuEl - Main menu HTML Element
 * 
 * @returns {void}
 */
const parseMenuMain = (menuEl) => {
  const blockIndex = parseInt(menuEl.getAttribute('data-level')) - 1;

  // menu type
  let menuType = 'primary';
  if (blockIndex > 0) {
    menuType = 'secondary';
  }
  if (blockIndex > 1) {
    menuType = 'tertiary';
  }
  
  const menu = {
    zoneId: parseInt(menuEl.getAttribute('data-zone-id')),
    menuType,
    backLabel: (blockIndex > 0) ? menuEl.getAttribute('aria-label').trim() : null,
    items: [],
  };
  
  Array.from(menuEl.querySelectorAll(':scope > [role="none"] > [role="menuitem"], :scope > [role="none"] > span')).forEach(el => {
    const isLink = el.tagName.toLowerCase() === 'a';
    const hasPopup = (el.hasAttribute('aria-haspopup') && el.getAttribute('aria-haspopup').toLowerCase() === 'true') ? true : false;
    const item = {
      targetZoneId: null,
      href: el.getAttribute('href') || '#',
      label: el.textContent.trim(),
      target: el.getAttribute('target') || '_self',
      isLink,
      classname: (isLink) ? Array.from(el.classList) : null,
    };
    if (hasPopup) {
      const submenuEl = el.closest('[role="none"]').querySelector(':scope > [role="menu"]');
      if (submenuEl && submenuEl.hasAttribute('data-zone-id')) {
        item.targetZoneId = parseInt(submenuEl.getAttribute('data-zone-id'));
        parseMenuMain(submenuEl);
      }
    }
    menu.items.push(item);
  });

  if (typeof menuMainMobile[blockIndex] === 'undefined') {
    menuMainMobile[blockIndex] = [menu];
  } else {
    menuMainMobile[blockIndex].push(menu);
  }
};

/**
 * Parse top menu into mobile menu "format"
 * 
 * @param {HTMLElement} menuEl - Top menu HTML Element
 * 
 * @returns {object[]}
 */
const parseMenuTop = (menuEl) => {
  const menu = {
    zoneId: parseInt(menuEl.getAttribute('data-zone-id')),
    menuType: 'alternate',
    backLabel: null,
    items: [],
  };
  Array.from(menuEl.querySelectorAll(':scope > [role="none"] > [role="menuitem"]')).forEach(el => {
    const isLink = el.tagName.toLowerCase() === 'a';
    menu.items.push({
      targetZoneId: null,
      href: el.getAttribute('href') || '#',
      label: el.textContent.trim(),
      target: el.getAttribute('target') || '_self',
      isLink,
      classname: (isLink) ? Array.from(el.classList) : null,
    });
  });
  return menu;
};

/**
 * Parse language selector menu into mobile menu "format"
 * 
 * @param {HTMLElement} menuEl - Top menu HTML Element
 * 
 * @returns {object[]}
 */
const parseMenuLang = (menuEl) => {
  const items = [];
  Array.from(menuEl.querySelectorAll(':scope > [role="none"] > [role="menuitem"]')).forEach(el => {
    const isExternal = el.classList.contains('external');
    const isActive = el.classList.contains('active');
    items.push({
      href: el.getAttribute('href') || '#',
      label: el.textContent.trim(),
      aria_label: el.getAttribute('aria-label').trim() || null,
      target: el.getAttribute('target') || '_self',
      isExternal,
      isActive,
    });
  });
  return items;
};
